export default __webpack_public_path__ + "static/media/privacy_policy.6ff7f170.pdf";